import React, { useCallback, useContext, useEffect, useState } from 'react';
import _ from 'lodash';

import Inputs from 'components/Inputs';
import { GroupsContext } from 'contextProviders/SplashScreenProviders/UserAndAccountProviders/GroupsProvider';

const MultiGroupSelect = ({
  selectedGroupIds,
  setSelectedGroupIds,
}: {
  selectedGroupIds: string[];
  setSelectedGroupIds: React.Dispatch<React.SetStateAction<string[]>>;
}) => {
  const { groups } = useContext(GroupsContext);

  const buildOptions = useCallback((): DropdownOption[] => {
    return _.sortBy(
      groups.filter((g) => !g.isHidden),
      ['name'],
    ).map((g) => ({
      key: g.id,
      value: g.id,
      label: g.name,
      isSelected: selectedGroupIds.includes(g.id),
      onSelected: () =>
        setSelectedGroupIds((current) => {
          if (current.includes(g.id)) {
            return current.filter((id) => id !== g.id);
          }
          return [...current, g.id];
        }),
    }));
  }, [groups, selectedGroupIds, setSelectedGroupIds]);

  const [options, setOptions] = useState<DropdownOption[]>(() =>
    buildOptions(),
  );
  useEffect(() => {
    setOptions(buildOptions());
  }, [buildOptions]);

  return (
    <Inputs.Dropdown
      isMulti
      isSearchEnabled
      options={options}
      placeholder="Select Groups"
      testId="group-selector"
    />
  );
};

export default MultiGroupSelect;
